import { useChangeBrandHandleApi, useChangeBrandNameApi, useChangeBrandWebsiteApi, useGetBrandApi } from "brand/api";
import { BrandIconFileUpload, BrandLogoFileUpload } from "components/FileUpload/FileUploadWithValue";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import React from "react";
import Panel from "../../components/panels/panel";
import TwoColumnLayout from "../../layout/TwoColumnLayout";
import BrandEsignColorPicker from "./BrandEsignColorPicker";
import BrandOptionsPanel from "./BrandOptionsPanel";
import BrandInputField from "./form/BrandInputField";
import { useLoaderData } from "react-router";

const BrandEdit = () => {
  const viewModel = useLoaderData<server.viewmodel.BrandEditFrontModel>();

  const brandsApi = useGetBrandApi(viewModel.brand);
  const brand = brandsApi.data;
  const [logoUrl, setLogoUrl] = React.useState<string>(brand.logoUrl);
  const [iconUrl, setIconUrl] = React.useState<string>(brand.iconUrl);

  const editPanel = <Panel
    panelClassName="s1_panel"
    title={viewModel.pageTitle}
    headerSize="h1"
    articleId={serverReference.supportArticleIds.branding}
    contentCssClass="flex-column gap-bigger"
  >
    <div>
      <BrandInputField<server.dto.SetBrandNameInstruction>
        brand={brand}
        initialText={brand.name}
        explanation={RESX.Branding.NameExplanation}
        maxLength={serverReference.constants.brand.maxNameLength}
        useMutation={useChangeBrandNameApi}
        createInstruction={(name) => ({ brandId: brand.brandId, name })}
      />
    </div>

    <div>
      <BrandInputField<server.dto.SetBrandFriendlyIdInstruction>
        title={RESX.Branding.Handle}
        brand={brand}
        initialText={brand.friendlyId}
        explanation={RESX.Branding.HandleExplanation}
        maxLength={serverReference.constants.brand.maxNameLength}
        useMutation={useChangeBrandHandleApi}
        createInstruction={(friendlyId) => ({ brandId: brand.brandId, friendlyId })}
      />
    </div>

    <div>
      <BrandInputField<server.dto.SetBrandWebsiteInstruction>
        title={"Brand website"}
        brand={brand}
        initialText={brand.website ?? ""}
        explanation={""}
        maxLength={serverReference.constants.brand.maxDomainLength}
        useMutation={useChangeBrandWebsiteApi}
        createInstruction={(website) => ({ brandId: brand.brandId, website })}
      />
    </div>
    <div className="flex gap-big">
      <div className="flex-column" style={{ flex: 2 }}>
        <div className="margin-bottom-small">Brand logo</div>
        <BrandLogoFileUpload
          brandId={brand.brandId}
          url={logoUrl}
          onUploadComplete={(_, downloadUrl) => {
            setLogoUrl(downloadUrl);
          }}
        />
      </div>
      <div className="flex-column" style={{ flex: 1 }}>
        <div className="margin-bottom-small">Square logo</div>
        <BrandIconFileUpload
          brandId={brand.brandId}
          url={iconUrl}
          onUploadComplete={(_, downloadUrl) => {
            setIconUrl(downloadUrl);
          }}
        />
      </div>
    </div>

    <div>
      <BrandEsignColorPicker brand={brand} />
    </div>
  </Panel>;

  const hasMultipleBrands = viewModel.optionsPanel.recordCount > 1;
  if (!hasMultipleBrands) {
    return <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        {editPanel}
      </TwoColumnLayout.LeftColumn>
      <RightSideNavigation
        title={site.navigation.rightSideNavigation.title}
        menuItems={site.navigation.rightSideNavigation.items}
        currentPage={site.currentPage}
      />
    </TwoColumnLayout>;
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          {editPanel}
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BrandOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            brand={brand}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default BrandEdit;